import React from "react";
import { Modal, Button } from "react-bootstrap";
import { Mode } from "./constant";

class AddFeatureModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      id: "",
      external_feature_id: "",
      description: "",
      mode: Mode.NEW,
      isSaving: false,
    };
    this.onSave = this.onSave.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  async componentWillReceiveProps(nextProps) {
    if (nextProps.mode === Mode.NEW) {
      this.setState({
        id: "",
        external_feature_id: "",
        description: "",
        mode: Mode.NEW,
        isSaving: false,
      });
    } else if (nextProps.mode === Mode.EDIT) {
      this.setState({
        id: nextProps.feature.id,
        external_feature_id: nextProps.feature.external_feature_id,
        description: nextProps.feature.description,
        mode: Mode.EDIT,
      });
    }
  }

  handleChange(event) {
    this.setState({
      [event.target.id]: event.target.value,
    });
  }

  async onSave() {
    this.setState({
      isSaving: true,
    });
    await this.props.onSave(this.state, this.props.mode);
    this.setState({
      isSaving: false,
    });
  }

  render() {
    const { external_feature_id, description } = this.state;

    return (
      <Modal
        show={this.props.show}
        onHide={this.props.onHide}
        aria-labelledby="contained-modal-title-lg"
        backdrop="static"
      >
        <Modal.Header>
          <h3> {this.state.mode === Mode.NEW ? "Add New" : "Edit"} Feature</h3>
        </Modal.Header>
        <Modal.Body>
          <div className="container-fluid">
            <label>Value</label>
            <input
              id="external_feature_id"
              type="number"
              className="form-control"
              value={external_feature_id}
              onChange={this.handleChange}
              disabled={this.state.mode === Mode.EDIT}
            ></input>
          </div>
          <div className="container-fluid">
            <label>Description</label>
            <input
              id="description"
              type="text"
              className="form-control"
              value={description}
              onChange={this.handleChange}
            ></input>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="btn btn-primary pull-right"
            disabled={this.state.isSaving}
            style={{ marginLeft: 10 }}
            onClick={() => {
              this.onSave();
            }}
          >
            Save
            {this.state.isSaving ? (
              <span>
                <i className="fa fa-spinner fa-spin" />
              </span>
            ) : (
              <span></span>
            )}
          </Button>
          <Button className="btn btn-secondary" onClick={this.props.onHide}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default AddFeatureModal;
